<template lang="pug">
  div
    v-tabs(v-model='active' color="grey lighten-3"  grow )
      v-tab() General
      v-tab-item
        General(@generalInfo="generalInfoSave"  :branchOfficeId="getBranchOfficeId")
      //- v-tab() Productos
      //- v-tab-item
      //-   Products(@products="productsSet")
      v-tab(:disabled="disabledComercialTab") Comercial
      v-tab-item
        Comercial(@comercialInfo="comercialInfoSave" :promo="gInfo" :branchOfficeId="getBranchOfficeId")
      v-tab(:disabled="disabledInventoryTab") Inventario
      v-tab-item
        Inventory(:promo="gComercial" :branchOfficeId="getBranchOfficeId")

</template>

<script>
/* components */
import General from '../create/general/GeneralInformation'
import Comercial from '../create/comercial/ComercialInformation'
import Inventory from '../create/inventory/InventoryInformation'
/* Models */
import ItemModel from '@/models/Warehouse/WhItem'
/* vuex */
import {mapActions} from 'vuex'
import BranchOfficeService from '@/services/api/branchOffice/'

export default {
  name: 'create-product-tab-component',
  // props: {},
  data: function(){
    return {
      active: null,
      gInfo:{},
      gComercial:{},
      gInventory:{},
      model :new ItemModel(),
      branchOfficesId:[],
      disabledComercialTab:true,
      disabledInventoryTab:true,
    }
  },
  computed: {
    
    getBranchOfficeId(){
      return this.branchOfficesId
    }
  },
  methods: {
    // -- UI Modification
    // -- Data fetching
    // -- Data handling and transformations
    generalInfoSave(event){
      this.gInfo = event
      this.disabledComercialTab = false
      this.nextTab()
    },
    /*
     */
    comercialInfoSave(event){
      console.log(event,'comercila event')
      this.gComercial = event
      this.disabledInventoryTab = false
      this.nextTab()
    },
    // -- Validations and Error handling
    // -- Other functions
    /*
     */
    nextTab () {
      const active = parseInt(this.active)
      this.active = (active < 2 ? active + 1 : 0)
    },
    /* 
     */
    async fetchAllBranchOffices(){
      let branches = await BranchOfficeService.fetchAll()
      this.setBranchOfficeId( this.getIdBranchOffices(branches) )
    },
    /* 
     */
    getIdBranchOffices(branches){
      return branches.map(b=>b.id)
    },
    /*
     */
    setBranchOfficeId(val){
      this.branchOfficesId = val
    },
    /*
     */
    productsSet(val){
      this.productsSelected = val
      this.nextTab()
    },

    // -- Vuex mappings
    ...mapActions('MenuesModule', {
      setTitleTopBar: 'setTitleTopBar',
    }),
  },
  //watch: {},
  components: {
    General,
    Comercial,
    Inventory,
  },
  // mixins: [],
  // filters: {},
  // -- Lifecycle Methods
  beforeMount: function() {
        this.setTitleTopBar('PROMOCIÓN')
        this.fetchAllBranchOffices()
    },
  // -- End Lifecycle Methods
}
</script>

<style lang="scss">
  
</style>